let enableAnalytics = true; // 是否开启埋点
let latestUserConsentResult;
let consentReady = false; // consent 是否已就绪（用户做出选择）
let gtmSDKLoaded = false;
/**
 * 初始化 gtm
 * @param options
 */
export function initGTM(options) {
    if (!options.id) {
        return;
    }
    enableAnalytics = !!(typeof options === 'object' && options.analytics);
    const initFn = () => {
        innerInitGTM(options.id, options.source || '', () => {
            gtmSDKLoaded = true;
            if (options.needConsent) {
                setTimeout(() => {
                    grantConsentGTM();
                });
            }
        });
    };
    if (options.needConsent) {
        // ga 隐私相关的设置
        gtag('consent', 'default', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 400
        });
    }
    if (options.delay && options.delay > 0) {
        setTimeout(initFn, options.delay);
    }
    else {
        initFn();
    }
}
/**
 * 确认数据相关的协议
 */
export function confirmConsent(result) {
    latestUserConsentResult = result;
    consentReady = true;
    if (gtmSDKLoaded) {
        grantConsentGTM();
    }
}
/**
 * 初始化 gtm
 * @param gtmId
 */
function innerInitGTM(gtmId, source, callback) {
    ;
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            (source || 'https://www.googletagmanager.com/gtm.js') + '?id=' + i + dl;
        f.parentNode && f.parentNode.insertBefore(j, f);
        j.onload = () => {
            callback();
        };
    })(window, document, 'script', 'dataLayer', gtmId);
    return true;
}
function grantConsentGTM() {
    const consentValue = {};
    if (latestUserConsentResult) {
        let needUpdate = false;
        if (latestUserConsentResult.ad) {
            consentValue.ad_storage = 'granted';
            consentValue.ad_user_data = 'granted';
            consentValue.ad_personalization = 'granted';
            needUpdate = true;
        }
        if (latestUserConsentResult.analytics) {
            consentValue.analytics_storage = 'granted';
            needUpdate = true;
        }
        if (needUpdate) {
            gtag('consent', 'update', consentValue);
        }
    }
}
/**
 * gtag 命令
 * @param params
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function gtag(..._params) {
    // eslint-disable-next-line prefer-rest-params
    setDataLayer(arguments);
}
/**
 * 将数据写入 dataLayer
 * @param params
 */
export function setDataLayer(params = {}) {
    var _a;
    const dataLayer = (window.dataLayer = (_a = window.dataLayer) !== null && _a !== void 0 ? _a : []);
    dataLayer.push(params);
}
function innerTrackGTMEvent(event, params = {}) {
    if (params.ecommerce) {
        // 如果是电商事件，先清除之前的电商对象
        setDataLayer({
            ecommerce: null
        });
    }
    setDataLayer(Object.assign({ event }, params));
}
/**
 * 触发 gtm 事件
 * @param event
 * @param params
 */
export function trackGTMEvent(event, params = {}) {
    if (consentReady) {
        innerTrackGTMEvent(event, params);
    }
    else {
        eventQueue.push({
            event,
            params,
            action: 'event',
            gtm: true
        });
        if (!eventLoopTimer) {
            eventLoopTimer = setInterval(() => {
                trackEventFromQueue();
            }, 1000);
        }
    }
}
let gaMeasurementId = ''; // 衡量 id 在一个页面中只能引入一个
let eventQueue = []; // 异常上报队列
/**
 * 从 gtm 全局变量中获取 ga 衡量id
 */
function getGAMeasurementId() {
    if (!gaMeasurementId) {
        if (window.google_tag_manager) {
            const keys = Object.keys(window.google_tag_manager);
            for (const key of keys) {
                if (key.startsWith('G-')) {
                    gaMeasurementId = key;
                    break;
                }
            }
        }
    }
}
let eventLoopTimer;
/**
 * 触发缓存队列中的异常事件
 */
function trackEventFromQueue() {
    getGAMeasurementId();
    if (gaMeasurementId &&
        window.google_tag_manager &&
        window.google_tag_manager.mb) {
        if (!consentReady) {
            const configs = eventQueue.filter((r) => r.action === 'config' && !r.gtm);
            for (const item of configs) {
                innerConfigGA(item.params);
            }
            if (configs.length) {
                eventQueue = eventQueue.filter((r) => r.action !== 'config' || r.gtm);
            }
            return;
        }
        if (eventLoopTimer) {
            clearInterval(eventLoopTimer);
            eventLoopTimer = 0;
        }
        while (eventQueue.length) {
            const item = eventQueue.shift();
            if (item) {
                if (item.gtm) {
                    innerTrackGTMEvent(item.event, item.params);
                }
                else {
                    innerTrackGAEvent(item.event, item.params);
                }
            }
        }
    }
}
/**
 * 触发 ga 事件
 * @param event
 * @param params
 */
function innerTrackGAEvent(event, params = {}) {
    params.send_to = gaMeasurementId;
    if (window.google_tag_manager) {
        window.google_tag_manager.mb.enqueue(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (function (_cmd, _event, _params) {
            // eslint-disable-next-line prefer-rest-params
            return arguments;
        })('event', event, params), 0, {});
    }
}
/**
 * 触发 ga 事件
 * @param event
 * @param params
 */
export function trackGAEvent(event, params = {}) {
    if (!enableAnalytics) {
        return console.log({
            event,
            params
        });
    }
    getGAMeasurementId();
    if (gaMeasurementId && consentReady) {
        trackEventFromQueue();
        innerTrackGAEvent(event, params);
    }
    else {
        eventQueue.push({
            event,
            params
        });
        if (!eventLoopTimer) {
            eventLoopTimer = setInterval(() => {
                getGAMeasurementId();
                trackEventFromQueue();
            }, 1000);
        }
    }
}
/**
 * 获取 ga 配置，暂时没处理 gtm ready 状态
 * @param key
 * @returns
 */
export function getGAConfig(key) {
    return new Promise((resolve, reject) => {
        getGAMeasurementId();
        if (gaMeasurementId && window.google_tag_manager) {
            window.google_tag_manager.mb.enqueue(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (function (_cmd, _sendTo, _key, _callback) {
                // eslint-disable-next-line prefer-rest-params
                return arguments;
            })('get', gaMeasurementId, key, (res) => {
                resolve(res);
            }), 0, {});
        }
        else {
            reject(new Error('ga not ready'));
        }
    });
}
/**
 * 配置 ga，设置公共属性
 * @param params
 */
function innerConfigGA(params) {
    if (window.google_tag_manager) {
        window.google_tag_manager.mb.enqueue(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (function (_cmd, _gaMeasurementId, _params) {
            // eslint-disable-next-line prefer-rest-params
            return arguments;
        })('config', gaMeasurementId, params), 0, {});
    }
}
/**
 * 设置 ga 配置
 * @param params
 */
export function setGAConfig(params) {
    if (!enableAnalytics) {
        return console.log('config ga:', params);
    }
    getGAMeasurementId();
    if (gaMeasurementId) {
        trackEventFromQueue();
        innerConfigGA(params);
    }
    else {
        eventQueue.push({
            event: '',
            params,
            action: 'config'
        });
        if (!eventLoopTimer) {
            eventLoopTimer = setInterval(() => {
                getGAMeasurementId();
                trackEventFromQueue();
            }, 1000);
        }
    }
}
